import { render, staticRenderFns } from "./ContextMenuRetornoPagamento.vue?vue&type=template&id=87280580&scoped=true&"
import script from "./ContextMenuRetornoPagamento.vue?vue&type=script&lang=js&"
export * from "./ContextMenuRetornoPagamento.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuRetornoPagamento.vue?vue&type=style&index=0&id=87280580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87280580",
  null
  
)

export default component.exports